export default [
    {
        btnsStatus100510 : {
              btn1:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
              },
              btn3:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Discusión',
                primaryMovil: false,
                displayMovil: 'block'
              },
              btn4:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
              },
              btn5:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
              }
        },
        btnsStatus100512 : {
            btn1:{
              labelComplete: 'null',
              primaryComplete: false,
              displayComplete: 'none',
              labelMovil: 'null',
              primaryMovil: false,
              displayMovil: 'none'
            },
            btn3:{
              labelComplete: 'null',
              primaryComplete: false,
              displayComplete: 'none',
              labelMovil: 'null',
              primaryMovil: false,
              displayMovil: 'none'
            },
            btn4:{
              labelComplete: 'null',
              primaryComplete: false,
              displayComplete: 'none',
              labelMovil: 'null',
              primaryMovil: false,
              displayMovil: 'none'
            },
            btn5:{
              labelComplete: 'null',
              primaryComplete: false,
              displayComplete: 'none',
              labelMovil: 'null',
              primaryMovil: false,
              displayMovil: 'none'
            }
        },
        btnsStatus100515 : {
            btn1:{
                labelComplete: 'Salir',
                primaryComplete: false,
                displayComplete: 'block',
                labelMovil: 'Salir',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn3:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Discusión',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn4:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Consultar cuestionario',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn5:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
            }
        },
        btnsStatus100520 : {
            btn1:{
                labelComplete: 'Salir',
                primaryComplete: false,
                displayComplete: 'block',
                labelMovil: 'Salir',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn3:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Discusión',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn4:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
            },
            btn5:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'null',
                primaryMovil: false,
                displayMovil: 'none'
            }
        },
        btnsStatus100525 : {
            btn1:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Regresar a abogado',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn3:{
                labelComplete: 'null',
                primaryComplete: true,
                displayComplete: 'none',
                labelMovil: 'Discusión',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn4:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Consultar cuestionario',
                primaryMovil: false,
                displayMovil: 'block'
            },
            btn5:{
                labelComplete: 'null',
                primaryComplete: false,
                displayComplete: 'none',
                labelMovil: 'Consultar contrato',
                primaryMovil: false,
                displayMovil: 'block'
            }
        }
    }
]